import { LiveListOption } from '../../../../apis/hooks/models/liveListOption';
import { hasCharacters } from '../../../../utils/text';
import { joinAddressParts } from '../../../../utils/addresses';

export const defaultNewOrderValues = {
	po: '',
	dueDate: null,
	product: '',
	quantity: '',
	shipToAddress: '',
};

export const getProductOptionLabel = (option) => {
	if (typeof option === 'string') {
		return option;
	}

	const label = option?.label ?? '';
	const designNumber = option?.metadata?.designNumber ?? '';

	return hasCharacters(designNumber) ? `${label} (${designNumber})` : label;
};

export const toProductOptions = (data) => {
	const rawOptions = Array.isArray(data?.items) ? data.items : [];
	return rawOptions.map((option) => new LiveListOption(option));
};

export const getShipToAddressOptionLabel = (option) => {
	if (typeof option === 'string') {
		return option;
	}

	return option?.label ?? '';
};

export const serializeFormValues = (values = defaultNewOrderValues) => ({
	...defaultNewOrderValues,
	...values,
	dueDate: values?.dueDate ? new Date(values.dueDate).toISOString() : null,
});

export const hydrateFormValues = (values = defaultNewOrderValues) => ({
	...defaultNewOrderValues,
	...values,
	dueDate: values?.dueDate ? new Date(values.dueDate) : null,
});

export const submitNewOrderRequest = (items) =>
	new Promise((resolve) => {
		window.setTimeout(() => {
			resolve({
				referencePo: `PO-${Math.floor(Date.now() / 1000)}`,
				totalQuantity: items.reduce(
					(sum, item) => sum + Number(item.quantity || 0),
					0
				),
				totalProductCount: items.length,
				items: items.map((item, index) => ({
					id: item.value,
					itemNumber: String(index + 1).padStart(4, '0'),
					value: item.value,
					label: item.label,
					designNumber: item.designNumber,
					quantity: item.quantity,
				})),
			});
		}, 400);
	});
